import React, { useState } from 'react'
import cn from 'classnames'
import { FormattedDate, FormattedMessage } from 'react-intl'
import convert from 'htmr'
import MoreButton from 'js/pages/NutritionExplained/components/MoreButton'

type Props = {
  references: Array<{
    id: any
    source: string | null
    title: string | null
    accessDate: any | null
  }>
}

function References({ references }: Props) {
  const [open, setOpen] = useState(false)

  if (!references.length) return null

  return (
    <div className="mb-24">
      <MoreButton
        className="inline-block text-center"
        use="h2"
        arrow
        open={open}
        onClick={() => setOpen(!open)}
        aria-controls="references"
      >
        <FormattedMessage
          id="references_toggle_button"
          defaultMessage="{count, plural, one {# reference} other {# references}}"
          values={{ count: references.length }}
        />
      </MoreButton>
      <ol
        className={cn(
          'type-small ml-20 mt-32 text-left leading-body',
          open ? 'block' : 'hidden',
        )}
        id="references"
        aria-expanded={open}
      >
        {references.map(({ id, source, title, accessDate }) => {
          if (!source || !title) {
            throw new Error(
              `typeguard: required reference source (${source}) or title (${title}) was missing`,
            )
          }
          return (
            <li
              key={id}
              className={`
                my-16 list-decimal border-b-1 border-BorderSub
                pb-16 font-demibold last:border-0
              `}
            >
              <h3>{source}</h3>
              <div className="font-regular">
                <p>
                  <span className="s-text">{convert(title)}</span>
                </p>
                {accessDate && (
                  <p className="type-nano block leading-body text-grey">
                    Accessed <FormattedDate value={accessDate as string} />
                  </p>
                )}
              </div>
            </li>
          )
        })}
      </ol>
    </div>
  )
}

export default References
